export default __webpack_public_path__ + "static/media/PC_ButtonInActive.b60c11d8.svg";